// extracted by mini-css-extract-plugin
export var actions = "_rn-4";
export var item = "_rn-1";
export var price = "_rn-3";
export var quantity = "_rn-2";
export var table = "_rn-0";